import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    content: `You still have {invitationsLeft} access(es) included in your offer. This doesn’t limit you. 
      Give your team additional accesses for €5/month/person. (excl. tax).
      Accounting accesses remain free and unlimited.`,
    new: 'New',
    title: 'Need more accesses? It’s possible.',
  },
  fr: {
    content: `Il vous reste {invitationsLeft} accès inclus dans votre offre. Cela ne vous limite pas.
    Donnez des accès supplémentaires à votre équipe pour 5 € / mois / pers.
    Les accès comptables restent illimités et gratuits.`,
    new: 'Nouveau',
    title: 'Besoin de plus d’accès ? C’est possible.',
  },
} as const);

export default locales;
